export const TextUnderline = ({ children }: { children?: React.ReactNode }) => {
  return (
    <span className="highlight group underline has-[.highlight]:no-underline">
      {children}
    </span>
  )
}
